<template>
  <div class="meditationlibrary audio-categories container-fluid">
    <div class="container-fluid">
      <div class="row" id="">
        <div class="col-md-12">
          <b-card no-body id="meditationLibraryAudioCard" class="p-3 mx-1">
            <b-card-body class="p-md-3 pt-md-0 p-0 pt-3">
              <div class="row my-2">
                <div class="col">
                  <h3
                    class="media-category-title media-category-title-doom-yoga"
                  >
                    Categories
                  </h3>
                </div>
              </div>

              <dataset
                v-slot="{ ds }"
                :ds-data="category_list"
                :ds-filter-fields="{
                  title: startsWithFilter,
                }"
                :ds-search-in="['title']"
                :ds-search-as="{}"
                showEntries="6"
              >
                <div class="row mb-2" :data-page-count="ds.dsPagecount">
                  <div class="col-xl-7 col-md-6">
                    <b-input-group
                      class="input-group-search input-group-search-doomyoga"
                    >
                      <template #prepend>
                        <font-awesome-icon
                          icon="fa-solid fa-magnifying-glass"
                          size="lg"
                        />
                      </template>
                      <dataset-search
                        ds-search-placeholder="Search"
                        class="form-control-doomyoga"
                    /></b-input-group>
                  </div>
                  <div
                    class="col-xl-5 col-md-6 px-md-0 px-3 addButtonContainerDiv"
                  >
                    <b-button
                      variant="doomyoga-primary"
                      id=""
                      class="btn btn-filter m-0 btn-lg-doomyoga"
                      v-b-modal="'addCategoryModal'"
                      @click="clickAddCategory"
                    >
                      + Add New Category
                    </b-button>
                   
                    <!-- </div>
                  <div class="col-xl-2 col-md-3 pl-0 addButtonContainerDiv"> -->
                    <b-button
                      variant="doomyoga-info"
                      id=""
                      class="btn btn-filter m-0 btn-lg-doomyoga"
                      v-b-modal.saveAudioModal
                    >
                      + Add New Audio
                    </b-button>
                    <SaveAudio
                      type="meditation_library"
                      sub_type="audio"
                      action_type="add"
                      :playlist_list="category_list_select"
                    />
                  </div>
                </div>
                <dataset-show class="d-none" :ds-show-entries="8" />

                <div class="row">
                  <div class="col-md-12">
                    <dataset-item class="row mb-3">
                      <template #default="{ row }">
                        <div class="col-xl-3 col-md-4">
                          <router-link
                            v-if="
                              row.library_media != null &&
                              row.library_media.length > 0
                            "
                            :to="
                              '/doom_yoga/meditation_library/audio_category/' +
                              row.id
                            "
                            class="card-link eventLink"
                          >
                            <MediaGallery
                              :title="row.title"
                              :videos="row.library_media"
                              media_type="audio"
                            />
                          </router-link>
                          <NoMedia
                            v-else
                            :title="row.title"
                            message="No audios found"
                          />
                          <b-row
                            ><b-col>
                              <b-button-group
                                class="
                                  d-block
                                  text-center
                                  btn-group-actions-doomyoga
                                "
                              >
                                <b-button
                                  variant="doomyoga-primary"
                                  size="sm"
                                  @click="
                                    clickEditCategory(
                                      row.id,
                                      row.title,
                                      row.description
                                    )
                                  "
                                  >Edit</b-button
                                >
                                <b-button
                                  variant="doomyoga-info"
                                  size="sm"
                                  @click="clickDeleteCategory(row.id)"
                                  >Delete</b-button
                                ></b-button-group
                              ></b-col
                            ></b-row
                          >
                        </div>
                      </template>
                      <template #noDataFound>
                        <div class="col-md-12 pt-2">
                          <p class="text-center datasetNoFoundP noDataFoundDY">
                            No data found
                          </p>
                        </div>
                      </template>
                    </dataset-item>
                  </div>
                </div>
                <div
                  class="
                    d-flex
                    flex-md-row flex-column
                    justify-content-between
                    align-items-center
                  "
                >
                  <dataset-info
                    class="mb-2 mb-md-0 datasetInfo datasetInfoDY"
                  />
                  <dataset-pager class="datasetPagerDY" />
                </div>
              </dataset>
            </b-card-body>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import $ from "jquery";
import MediaGallery from "../media/MediaGallery.vue";
import SaveCategory from "../media/SaveCategory.vue";
import DeleteCategory from "../media/DeleteCategory.vue";
import SaveAudio from "../media/SaveAudio.vue";
import NoMedia from "../media/NoMediaCard.vue";

import {
  filterList,
  clone,
  isoDateToEuroDate,
  searchAsEuroDate,
} from "vue-dataset/docs/.vuepress/utilities";
import { debounce } from "vue-dataset/src/helpers";

export default {
  name: "MeditationLibraryAudioCategories",
  components: { MediaGallery, SaveCategory, DeleteCategory, SaveAudio, NoMedia },
  data() {
    return {
      client_name: "DY",

      category_list:[],
      category_list_select: [],

      onlineFilter: "",
      selected: 6,
      startsWith: "",

      modal_category: "meditation_library",
      modal_type: "audio",

      media_library: "meditation_library",
      save_category_modal_title: "Add New Category",
      selected_category_id: null,
      selected_category_title: null,
      selected_category_description: null,
      save_category_action_type: "add",
    };
  },
  mounted() {
    this.getMediaCategoryList();
  },
  computed: {},
  created() {
    this.startWithInput = debounce((e) => {
      this.startsWith = e.target.value;
    }, 100);
  },
  methods: {
    filterList,
    isoDateToEuroDate,
    searchAsEuroDate,
    updateData() {
      const updatedList = clone(category_list).slice(5, 5);
      this.category_list = updatedList;
    },
    startsWithFilter(value) {
      return value.toLowerCase().startsWith(this.startsWith.toLowerCase());
    },
    getMediaCategoryList() {
      console.log("in get categories");
      // this.category_list = [];
      let formData = new FormData();
      formData.append("media_library", this.media_library);
      formData.append("sub_library", "audio");
      axios
        .post("media/library/categories", formData, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: "DY",
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);
          console.log(response.data);
          this.category_list = response.data;
          this.category_list_select = response.data.slice(0);

          this.category_list_select.push({ title: "New category", id: "new" });
        });
    },
    clickAddCategory() {
      console.log("in click add category");

      this.$parent.$parent.$parent.clickAddCategory("audio")
      
    },
    clickEditCategory(id, title, description) {
      console.log("in click edit category");
      this.$parent.$parent.$parent.clickEditCategory(id, title, description, "audio")
    
    },
    clickDeleteCategory(id) {
      console.log("click delete category", id);
      this.$parent.$parent.$parent.clickDeleteCategory(id, "audio")
    
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/doom_yoga/meditation_library/AudioCategoryList.vue